export enum Province {
  QC = 'QC',
  ON = 'ON',
  AB = 'AB',
  BC = 'BC',
  MB = 'MB',
  NB = 'NB',
  NL = 'NL',
  NT = 'NT',
  NS = 'NS',
  NU = 'NU',
  PE = 'PE',
  SK = 'SK',
  YT = 'YT',
}

export const isProvinceSupportedForReferral = (province: Province | undefined) => {
  return supportedProvincesLifeInsuranceBroker.has(province as Province);
};

export const isProvinceSupportedLifeInsurance = (province: Province | undefined) => {
  return supportedProvincesLifeInsurance.has(province as Province);
};

export const isProvinceRequiresTrusteeForBeneficiaryUnder19YearsOld = (province: Province | undefined) => {
  return provinceThatRequiresTrusteeUnder19YearsOld.has(province as Province);
};

export const isProvinceRequiresTrusteeForBeneficiaryUnder18YearsOld = (province: Province | undefined) => {
  return provinceThatRequiresTrusteeUnder18YearsOld.has(province as Province);
};

const supportedProvincesLifeInsurance = new Set([
  Province.QC,
  Province.ON,
  Province.MB,
  Province.PE,
  Province.AB,
]);

const provinceThatRequiresTrusteeUnder19YearsOld = new Set([
  Province.BC,
  Province.NB,
  Province.NL,
  Province.NT,
  Province.NS,
  Province.NU,
  Province.YT,
]);

const provinceThatRequiresTrusteeUnder18YearsOld = new Set([
  ...provinceThatRequiresTrusteeUnder19YearsOld,
  Province.AB,
  Province.MB,
  Province.ON,
  Province.PE,
  Province.SK,
]);

const supportedProvincesLifeInsuranceBroker = new Set([Province.QC, Province.ON]);

export const getProvinceNameFromCode = (code: Province, fr: boolean): string => {
  const provinceNames = {
    [Province.QC]: {fr: 'Québec', en: 'Quebec'},
    [Province.ON]: {fr: 'Ontario', en: 'Ontario'},
    [Province.AB]: {fr: 'Alberta', en: 'Alberta'},
    [Province.BC]: {fr: 'Colombie-Britannique', en: 'British Columbia'},
    [Province.MB]: {fr: 'Manitoba', en: 'Manitoba'},
    [Province.NB]: {fr: 'Nouveau-Brunswick', en: 'New Brunswick'},
    [Province.NL]: {fr: 'Terre-Neuve-et-Labrador', en: 'Newfoundland and Labrador'},
    [Province.NT]: {fr: 'Territoires du Nord-Ouest', en: 'Northwest Territories'},
    [Province.NS]: {fr: 'Nouvelle-Écosse', en: 'Nova Scotia'},
    [Province.NU]: {fr: 'Nunavut', en: 'Nunavut'},
    [Province.PE]: {fr: 'Île-du-Prince-Édouard', en: 'Prince Edward Island'},
    [Province.SK]: {fr: 'Saskatchewan', en: 'Saskatchewan'},
    [Province.YT]: {fr: 'Yukon', en: 'Yukon'},
  };

  return provinceNames[code]?.[fr ? 'fr' : 'en'];
};
